import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ScrollToTop from "@/components/ScrollToTop";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index.tsx";
import Services from "./pages/Services.tsx";
import ServiceDetail from "./pages/ServiceDetail.tsx";
import ACTypes from "./pages/ACTypes.tsx";
import ACTypeDetail from "./pages/ACTypeDetail.tsx";
import Specials from "./pages/Specials.tsx";
import About from "./pages/About.tsx";
import Brands from "./pages/Brands.tsx";
import BrandDetail from "./pages/BrandDetail.tsx";
import FinanceOptions from "./pages/FinanceOptions.tsx";
import MembershipPage from "./pages/Membership.tsx";
import FAQ from "./pages/FAQ.tsx";
import OurProcess from "./pages/OurProcess.tsx";
import AreasWeService from "./pages/AreasWeService.tsx";
import SuburbDetailPage from "./pages/SuburbDetailPage.tsx";
import BlogPage from "./pages/BlogPage.tsx";
import BlogPostPage from "./pages/BlogPostPage.tsx";
import AdminLogin from "./pages/admin/AdminLogin.tsx";
import AdminDashboard from "./pages/admin/AdminDashboard.tsx";
import AdminBlogList from "./pages/admin/AdminBlogList.tsx";
import AdminBlogEditor from "./pages/admin/AdminBlogEditor.tsx";
import AdminBlogBulk from "./pages/admin/AdminBlogBulk.tsx";
import AdminAutoBlog from "./pages/admin/AdminAutoBlog.tsx";
import AdminBlogQueue from "./pages/admin/AdminBlogQueue.tsx";
import AdminBlogAuthors from "./pages/admin/AdminBlogAuthors.tsx";
import AdminAutoBlogSettings from "./pages/admin/AdminAutoBlogSettings.tsx";
import AdminIndexNow from "./pages/admin/AdminIndexNow.tsx";
import AdminClicks from "./pages/admin/AdminClicks.tsx";
import AdminUsers from "./pages/admin/AdminUsers.tsx";

import AdminBlogCategories from "./pages/admin/AdminBlogCategories.tsx";
import AdminSettings from "./pages/admin/AdminSettings.tsx";
import ProtectedAdminRoute from "./components/admin/ProtectedAdminRoute.tsx";
import ScheduleService from "./pages/ScheduleService.tsx";
import ScheduleQuote from "./pages/ScheduleQuote.tsx";
import ContactUs from "./pages/ContactUs.tsx";
import NotFound from "./pages/NotFound.tsx";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/ac-types" element={<ACTypes />} />
          <Route path="/ac-types/:slug" element={<ACTypeDetail />} />
          <Route path="/specials" element={<Specials />} />
          <Route path="/brands" element={<Brands />} />
          <Route path="/brands/:slug" element={<BrandDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/finance-options" element={<FinanceOptions />} />
          <Route path="/membership" element={<MembershipPage />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/our-process" element={<OurProcess />} />
          <Route path="/areas-we-service" element={<AreasWeService />} />
          <Route path="/areas-we-service/:slug" element={<SuburbDetailPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/schedule-service" element={<ScheduleService />} />
          <Route path="/schedule-quote" element={<ScheduleQuote />} />
          <Route path="/contact-us" element={<ContactUs />} />
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedAdminRoute><AdminDashboard /></ProtectedAdminRoute>} />
          <Route path="/admin/blog" element={<ProtectedAdminRoute><AdminBlogList /></ProtectedAdminRoute>} />
          <Route path="/admin/blog/new" element={<ProtectedAdminRoute><AdminBlogEditor /></ProtectedAdminRoute>} />
          <Route path="/admin/blog/bulk" element={<ProtectedAdminRoute><AdminBlogBulk /></ProtectedAdminRoute>} />
          <Route path="/admin/blog/auto" element={<ProtectedAdminRoute><AdminAutoBlog /></ProtectedAdminRoute>} />
          <Route path="/admin/blog/queue" element={<ProtectedAdminRoute><AdminBlogQueue /></ProtectedAdminRoute>} />
          <Route path="/admin/blog/auto-settings" element={<ProtectedAdminRoute><AdminAutoBlogSettings /></ProtectedAdminRoute>} />
          <Route path="/admin/blog/authors" element={<ProtectedAdminRoute><AdminBlogAuthors /></ProtectedAdminRoute>} />
          <Route path="/admin/blog/indexnow" element={<ProtectedAdminRoute><AdminIndexNow /></ProtectedAdminRoute>} />
          <Route path="/admin/blog/clicks" element={<ProtectedAdminRoute><AdminClicks /></ProtectedAdminRoute>} />
          <Route path="/admin/users" element={<ProtectedAdminRoute><AdminUsers /></ProtectedAdminRoute>} />

          <Route path="/admin/blog/categories" element={<ProtectedAdminRoute><AdminBlogCategories /></ProtectedAdminRoute>} />
          <Route path="/admin/blog/:id" element={<ProtectedAdminRoute><AdminBlogEditor /></ProtectedAdminRoute>} />
          <Route path="/admin/settings" element={<ProtectedAdminRoute><AdminSettings /></ProtectedAdminRoute>} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
